module.exports = __webpack_public_path__ + "img/esim_area_en.21bd67f0.png";